<template>
<div class="popup" v-show="optionDialogShow" v-cloak>
    <div class="content" id="transferOptions">
        <div class="title">
            {{$t('language.common.options')}}
            <div class="icon white-close dialog-close" @click="optionClose()"></div>
        </div>
        <div class="transfer-options-body">
            <div class="transfer-options-cont">
                <el-tabs v-model=activeName>
                    <el-tab-pane :label="$t('language.cloudTransfer.transfer')" name="first">
                        <tab1 ref="tab1" ></tab1>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('language.popup.email')" name="second">
                        <tab2 ref="tab2"></tab2>
                    </el-tab-pane>
                    <el-tab-pane name="third">
                        <span slot="label" class="transfer-vip">
                            <span>{{$t('language.popup.filter')}}</span>
                            <div class="icon-util vip filter-position"></div>
                        </span>
                        <tab3 ref="tab3"></tab3>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="transfer-options-footer">
                <button style="float:right;" @click="optionSubmit()">{{$t('language.common.save')}}</button>
                <button class="white-button" style="float:right;margin-right: 10px;" @click="optionClose()">{{$t('language.common.cancel')}}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import '@/assets/css/transfer_options.css'
import tab1 from "@/components/common/tabs/tabs_transfer_options/tab_transfer";
import tab2 from "@/components/common/tabs/tabs_transfer_options/tab_email";
import tab3 from "@/components/common/tabs/tabs_transfer_options/tab_filter";
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
export default {
    components: {
        tab1,
        tab2,
        tab3
    },
    data: function () {
        return {
            activeName: "first",
            optionDialogShow: false,
            tabs: [{
                name: this.$t('language.cloudTransfer.transfer')
            }, {
                name: this.$t('language.popup.email')
            }, {
                name: this.$t('language.popup.filter')
            }],
            indexCurrent: 0,
            tabBarClass: '',
            options: {
                replace: 2,
                isRemove: 0,
                isKeep: 0,
                isChar: 1,
            },
            oldOptions: {},
            source:'',//弹窗来源
        };
    },
    watch:{
      optionDialogShow(newValue,oldValue){
        //   if(newValue&&this.source!='teamTransfer'){
        //       if(!this.$refs.tab1.checkArr.includes(3)){
        //            this.$refs.tab1.checkArr.push(3);
        //            this.options.keepRoot=1;
        //       }
        //        if(!this.$refs.tab1.oldCheckArr.includes(3)){
        //            this.$refs.tab1.oldCheckArr.push(3);
        //       }
        //   }
        //    if(newValue&&this.source=='teamTransfer'){
        //        delete this.options.keepRoot;
        //   }
      }
    },
    methods: {
        optionSubmit() {
            delete this.options.matched;
            delete this.options.pattern;
            let user = commonUtils.getUser();
            //当用户勾选了邮箱但没有填邮箱
            if (!this.$refs.tab2.email && this.$refs.tab2.sendShow) {
                this.indexCurrent = 1;
                this.activeName = 'second';
                this.$refs.tab2.shakeBox = "email-shake";
                setTimeout(() => {
                    this.$refs.tab2.shakeBox = "box-shakeOrigin";
                }, 200);
            } else {
                if (this.$refs.tab2.email) {
                    if (!commonstate.emailpattern.test(this.$refs.tab2.email)) {
                        this.activeName = 'second';
                        this.$toast({
                            text: this.$t('language.login.enterCorrectEmai'),
                            type: 'fail',
                            idValue: "transferOptions"
                        });
                        return false;
                    }
                    this.options.email = this.$refs.tab2.email;
                } else {
                    delete this.options.email;
                }
                //用户保存filter数据
                if (this.$refs.tab3.items.length) {
                    //付费功能弹窗提醒
                    if (!user.vip) {
                        var upgradeNewDialog = this.$parent.$refs.upgradeNewDialog;
                        upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_filter');
                        upgradeNewDialog.curItem = 'filter';
                        upgradeNewDialog.isShow = true;
                        return false;
                    }
                    if (this.$refs.tab3.radioCurrent == 0) {
                        this.options.pattern = 'exclude';
                    } else if (this.$refs.tab3.radioCurrent == 1) {
                        this.options.pattern = 'include';
                    }
                    for (let i = 0; i < this.$refs.tab3.items.length; i++) {
                        if (this.options.matched) {
                            this.options.matched = this.options.matched + '*' + this.$refs.tab3.items[i] + '|';
                        } else {
                            this.options.matched = '*' + this.$refs.tab3.items[i] + '|';
                        }
                    }
                    let index = this.options.matched.lastIndexOf('|');
                    this.options.matched = this.options.matched.substring(0, index);
                }
                this.$parent.pOptions = Object.assign({}, this.options);
                this.$refs.tab1.oldSelectValue = this.$refs.tab1.$refs.cloudSelect.currentValue;
                this.$refs.tab1.oldCheckArr = Object.assign([], this.$refs.tab1.checkArr);
                this.optionDialogShow = false;
                //对旧数据进行拷贝
                this.oldOptions = Object.assign({}, this.options);
            }
        },
        optionClose() {
            let that = this;
            let suffix;
            //还原tab1用户之前选择的数据
            this.optionDialogShow = false;
            this.$refs.tab1.$refs.cloudSelect.currentValue = this.$refs.tab1.oldSelectValue;
            this.$refs.tab1.checkArr = Object.assign([], this.$refs.tab1.oldCheckArr);
            //还原tab2用户之前选择的数据
            if (this.oldOptions.email) {
                this.$refs.tab2.sendShow = true;
                this.$refs.tab2.email = this.oldOptions.email;
            } else {
                this.$refs.tab2.sendShow = false;
                this.$refs.tab2.email = "";
            }
            //还原tab3用户之前选择的数据
            that.$refs.tab3.inputValue = null;
            that.$refs.tab3.items = [];
            that.$refs.tab3.includeArr = [];
            that.$refs.tab3.ignoreArr = [];
            if (this.oldOptions.pattern) {
                let pattern = this.oldOptions.pattern;
                if (pattern == 'exclude') {
                    this.$refs.tab3.radioCurrent = 0;
                } else {
                    this.$refs.tab3.radioCurrent = 1;
                }
                let arr = this.oldOptions.matched.split('*');
                $.each(arr, function (i, item) {
                    if (item && i != arr.length - 1) {
                        suffix = item.substring(0, item.length - 1);
                        that.$refs.tab3.items.push(suffix);
                    }
                    if (i == arr.length - 1) {
                        suffix = item;
                        that.$refs.tab3.items.push(suffix);
                    }
                });
            }
        },
        clearAllData() {
             this.oldOptions={};
            this.activeName = 'first';
            this.$refs.tab2.sendShow = false;
            this.$refs.tab2.email = '';
            this.$refs.tab3.items = [];
            this.$refs.tab3.ignoreArr = [];
            this.$refs.tab3.includeArr = [];
            this.$refs.tab1.oldCheckArr = [2,3];
            this.$refs.tab1.checkArr = [2,3];
            this.$refs.tab1.oldSelectValue=this.$t('language.popup.skipFile');
            this.$refs.tab1.onChangeOption(this.$t('language.popup.skipFile'));
            this.$refs.tab1.$refs.cloudSelect.currentValue = this.$t('language.popup.skipFile');
        }
    }
};
</script>

<style>
#transferOptions #tab-first,
#transferOptions #tab-second {
    font-size: 14Px;
    height: 40Px;
    line-height: 40Px;
    position: relative;
}

#transferOptions #tab-third {
    font-size: 14Px;
    height: 40Px;
    position: relative;
    line-height: 40Px;
}

#tab-second {
    margin-left: 0 !important;
}

.is-top {
    margin: 0 !important;
}

#transferOptions .el-tabs__content {
    height: auto;
    /*no*/
    position: relative;
    width: 100%;
    font-size: 14px;
    /*no*/
    color: #6f7886;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 30px;
    /*no*/
    overflow: visible;

}
</style>




// WEBPACK FOOTER //
// src/components/popup/cloud_transfer_popups/transfer_options_popup.vue